<template>
<div>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<div class="grid">
<div class="col-12 md:col-12">




<template v-if="$store.state.evaluation.parentsections.length>1">

<h3 class="text-primary">{{$store.state.languages.lang_phrases.bolumler}}</h3>

<EvaluationSectionSelector v-for="item in $store.state.evaluation.parentsections" :data="item"></EvaluationSectionSelector>
</template>



</div>
</div>


</template>

</div>
</template>

<script>
export default {

  name: 'EvaluationProgress',

  data () {
    return {
    	loading:false,
    	data:null,
    }
  },
  mounted()
  {

    
  	this.getData()
  },
  computed:{
    flowtype()
    {
      if(this.$store.state.evaluation)
      {
        return this.$store.state.evaluation.evaluation.flow.type
      }
    }
  },
  watch:{
    flowtype(newval)
    {
      if(newval=="self_evaluation")
      {
        //document.title = this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(newval=="verification")
      {
        //document.title = this.$store.state.languages.lang_phrases.verification
      }

    }
  },
  methods:{
  	async getData()
  	{
    		

        if(this.$store.state.evaluation.parentsections.length==1)
        {
        	await this.$router.push({ name: 'EvaluationSection', params: { section_id:this.$store.state.evaluation.parentsections[0].id } })
        }
        await this.$store.dispatch('evaluation/setActiveParentSectionId',null) 

       

        this.loading = await false
  	}
  }
};
</script>

<style lang="css" scoped>
</style>